import React from 'react';
import {Row, Col, Button, Upload, Icon} from 'antd';
import FieldBlock from '../../../field-block';
import DividerBlock from "../../../divider-block";
import {getWithTranslate} from "../../../../helpers/doc_type.helper";
import i18n from '../../../../i18n';

export default function EditKazakhstanLegalEntityDocs({
                                                        docFields,
                                                        setDocFields,
                                                        fieldsErrors,
                                                        isProprietor,
                                                        isNeedPowerOfAttorneyForAPerson
                                                      }) {
  const legalEntityDataAliases = getWithTranslate('legalEntityDataAliases');
  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  const getUploaderClass = (name, multiple = true) => {
      const hasFiles = name in docFields;
      if (!hasFiles) {
          return null;
      }
    return {
      multiple: multiple,
      showUploadList: true,
      onRemove: (file) => {
        setDocFields({...docFields, [name]: null});
      },
      beforeUpload: (file, fileList) => {
        if (multiple) {
          if (docFields[name]) {
            setDocFields({...docFields, [name]: docFields[name].concat(fileList)});
          } else {
            setDocFields({...docFields, [name]: fileList});
          }
        } else {
          setDocFields({...docFields, [name]: file});
        }
        return false;
      },
      fileList: docFields[name],
      listType: 'picture',
    };
  };

  return (
    <Row gutter={20}>
      <DividerBlock label={i18n.t('modals.modalEditLegalEntityDocs.divider.docs')}/>
      {isProprietor ? null : (
        <>
        { 'protocolOfTheGeneralMeetingOfParticipants' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="protocolOfTheGeneralMeetingOfParticipants" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.protocolOfTheGeneralMeetingOfParticipants}
                      fileList={docFields.protocolOfTheGeneralMeetingOfParticipants}
                      className="single-btn-upload" {...getUploaderClass('protocolOfTheGeneralMeetingOfParticipants', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.protocolOfTheGeneralMeetingOfParticipants}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
            )}
        { 'proofOfOwnership' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="proofOfOwnership" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.proofOfOwnership} fileList={docFields.proofOfOwnership}
                      className="single-btn-upload" {...getUploaderClass('proofOfOwnership', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.proofOfOwnership}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
            )}
        { 'charterWithAllAmendments' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="charterWithAllAmendments" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.charterWithAllAmendments} fileList={docFields.charterWithAllAmendments}
                      className="single-btn-upload" {...getUploaderClass('charterWithAllAmendments', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.charterWithAllAmendments}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
            )}
        </>
      )}

      {isNeedPowerOfAttorneyForAPerson ? (
        <>
        { 'powerOfAttorneyForAPerson' in docFields &&(
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="powerOfAttorneyForAPerson" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.powerOfAttorneyForAPerson}
                      fileList={docFields.powerOfAttorneyForAPerson}
                      className="single-btn-upload" {...getUploaderClass('powerOfAttorneyForAPerson', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.powerOfAttorneyForAPerson}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
            )}
        </>
      ) : null}

        { 'certificateOfStateRegistration' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="certificateOfStateRegistration" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.certificateOfStateRegistration}
                  fileList={docFields.certificateOfStateRegistration}
                  className="single-btn-upload" {...getUploaderClass('certificateOfStateRegistration', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfStateRegistration}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
            )}
        { 'partnerCard' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="partnerCard" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.partnerCard} fileList={docFields.partnerCard}
                  className="single-btn-upload" {...getUploaderClass('partnerCard', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.partnerCardKz}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
            )}
        { 'residenceCertificate' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="residenceCertificate" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.residenceCertificate} fileList={docFields.residenceCertificate}
                  className="single-btn-upload" {...getUploaderClass('residenceCertificate', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.residenceCertificateKz}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
            )}
        { 'copyOfThePassport' in docFields &&(
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="copyOfThePassport" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.copyOfThePassport} fileList={docFields.copyOfThePassport}
                  className="single-btn-upload" {...getUploaderClass('copyOfThePassport', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.copyOfThePassportKz}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
            )}
        { 'license' in docFields &&(
            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                <FieldBlock name="license" getErrors={getFieldErrors}>
                    <Upload defaultFileList={docFields.license} fileList={docFields.license}
                            className="single-btn-upload" {...getUploaderClass('copyOfThePassport', true)}>
                        <Button htmlType="button">
                            <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.license}
                        </Button>
                    </Upload>
                </FieldBlock>
            </Col>
        )}
    </Row>
  );
}
